import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '@knownow/db'

const supabaseUrl = import.meta.env['VITE_SUPABASE_URL'] as string | undefined ?? ''
const supabaseKey = import.meta.env['VITE_SUPABASE_ANON_KEY'] as string | undefined ?? ''

function createSupabaseClient(): SupabaseClient<Database> {
  if (!supabaseUrl || !supabaseKey) {
    // Return a placeholder that won't crash module evaluation in dev.
    // Phase 2 will enforce auth and proper env validation at startup.
    return createClient<Database>('http://localhost:54321', 'placeholder')
  }
  return createClient<Database>(supabaseUrl, supabaseKey)
}

export const supabase = createSupabaseClient()
